<script lang="ts">
  import Flex from '$components/layout/Flex.svelte';
  import Grid from '$components/layout/Grid.svelte';
  import Image from '$components/utils/Image.svelte';
  import MediaQuery from '$components/utils/MediaQuery.svelte';

  export let image: string;
</script>

<MediaQuery query="(min-width: 721px)" let:matches>
  {#if matches}
    <div class="header">
      <Grid gap="70px" templateColumns="1fr 1fr" justifyContent="center">
        <Flex direction="column" alignItems="flex-start">
          <div class="header__content">
            <slot />
          </div>
        </Flex>
        <Image key={image} borderRadius="13px" width="100%" height="auto" thumb="1200x1000" />
      </Grid>
    </div>
  {:else}
    <div class="header">
      <Grid templateColumns="1fr" justifyContent="center">
        <Flex direction="column" alignItems="flex-start">
          <div class="header__content">
            <slot />
          </div>
        </Flex>
        <Image
          key={image}
          borderRadius="0"
          width="100vw"
          height="auto"
          margin="15px 0 0"
          thumb="1200x1000"
        />
      </Grid>
    </div>
  {/if}
</MediaQuery>

<style lang="scss">
  .header {
    align-self: center;
    margin-top: 160px;

    max-width: 1280px;
    width: 80vw;
  }
  @include mobile {
    .header {
      margin-top: 84px;

      &__content {
        padding-left: 5vw;
        padding-right: 5vw;
      }
    }
  }
</style>
